import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart } from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

export default function TariffTrendChart({ data, loading }) {
  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Tariff Exposure Over Time</CardTitle>
          <CardDescription>Volume and tariff trends</CardDescription>
        </CardHeader>
        <CardContent className="h-80 flex items-center justify-center bg-gray-50 rounded-lg animate-pulse">
          <span className="text-gray-400">Loading chart...</span>
        </CardContent>
      </Card>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Tariff Exposure Over Time</CardTitle>
          <CardDescription>Volume and tariff trends</CardDescription>
        </CardHeader>
        <CardContent className="h-80 flex items-center justify-center bg-gray-50 rounded-lg">
          <span className="text-gray-500">No trend data available</span>
        </CardContent>
      </Card>
    );
  }

  const formatCurrency = (value) => {
    return `$${(value / 100).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
  };

  const formatVolume = (value) => {
    return value.toLocaleString('en-US');
  };

  const chartData = data.map(item => ({
    period: item.period,
    volume: item.volume,
    tariff: item.tariff_cents / 100,
    value: item.value_cents / 100
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Tariff Exposure Over Time</CardTitle>
        <CardDescription>Volume and tariff impact by period</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={320}>
          <ComposedChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis
              dataKey="period"
              stroke="#888888"
              fontSize={12}
              tickLine={false}
            />
            <YAxis
              yAxisId="left"
              stroke="#888888"
              fontSize={12}
              tickLine={false}
              tickFormatter={formatVolume}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              stroke="#888888"
              fontSize={12}
              tickLine={false}
              tickFormatter={(value) => `$${(value / 1000).toFixed(0)}K`}
            />
            <Tooltip
              content={({ active, payload }) => {
                if (active && payload && payload.length) {
                  return (
                    <div className="bg-white p-3 shadow-lg rounded-lg border border-gray-200">
                      <p className="font-semibold text-gray-900 mb-2">{payload[0].payload.period}</p>
                      <p className="text-sm text-gray-600">
                        Volume: <span className="font-medium text-gray-900">{formatVolume(payload[0].payload.volume)}</span>
                      </p>
                      <p className="text-sm text-orange-600">
                        Tariff: <span className="font-medium">{formatCurrency(payload[0].payload.tariff * 100)}</span>
                      </p>
                      <p className="text-sm text-blue-600">
                        Value: <span className="font-medium">{formatCurrency(payload[0].payload.value * 100)}</span>
                      </p>
                    </div>
                  );
                }
                return null;
              }}
            />
            <Legend wrapperStyle={{ paddingTop: '20px' }} />
            <Bar yAxisId="left" dataKey="volume" fill="#93c5fd" name="Volume" radius={[4, 4, 0, 0]} />
            <Line yAxisId="right" type="monotone" dataKey="tariff" stroke="#f97316" strokeWidth={2} name="Tariff ($)" dot={{ fill: '#f97316', r: 4 }} />
          </ComposedChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
